import React, { PropsWithChildren } from 'react';
import { ISelectOption, Select } from '../Select';
import { FilterEventHandler, IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
// import { useSortEventListenerFix } from './useSortEventListenerFix';
import styled from 'styled-components';
import { convertNullToUndefined } from '../../utilities/convertNullToUndefined';
import { ICustomSelectFilterProps } from 'react-bootstrap-table2-filter';

export interface ISelectFilterProps<T extends object = {}> extends Omit<ICustomSelectFilterProps, 'type'> {
  onFilter: FilterEventHandler;
  column: IBootstrapTableColumnProps<T>;
  options: ISelectOption[];
}

const StyledSelectInput = styled(Select)`
  width: 100%;
`;

export const SelectFilter = <T extends object = {}>({
  column,
  defaultValue,
  onFilter,
  options,
}: PropsWithChildren<ISelectFilterProps<T>>) => {
  //FYI: preventing event bubbling because BootstrapTable sorts when focusing filter elements
  // const clickEventInputRef = useSortEventListenerFix();

  return (
    <StyledSelectInput
      // getInputRef={clickEventInputRef}
      options={options}
      onChange={(newValue: ISelectOption | null) => onFilter(convertNullToUndefined(newValue?.value))}
      placeholder={column.text}
      value={options.find((o) => o.value === defaultValue) ?? undefined}
      isClearable
    />
  );
};

interface ISelectFilterRendererProps extends Omit<ICustomSelectFilterProps, 'type'> {}

export const SelectFilterRenderer =
  <T extends object>(config: ISelectFilterRendererProps) =>
  (onFilter: FilterEventHandler, column: IBootstrapTableColumnProps<T>) => (
    <SelectFilter {...config} column={column} onFilter={onFilter} />
  );
